import { Fragment } from 'react';

import { Applicant } from '../../Applicant.types';
import { CompareSideProvider } from '../ApplicationCompare';
import { getApplicationSections } from '../ApplicationView';
import { AlignedCompareGrid } from './ApplicantSubmissions.StyledComponents';
import { alignApplicationSections } from './ApplicantSubmissions.utils';

interface ComparedApplication {
    applicant: Applicant;
    isSubmission: boolean;
}

interface AlignedApplicationCompareProps {
    left: ComparedApplication;
    right: ComparedApplication;
}

export const AlignedApplicationCompare = ({ left, right }: AlignedApplicationCompareProps) => (
    <AlignedCompareGrid data-testid="aligned-application-compare">
        {alignApplicationSections(
            getApplicationSections(left.applicant, left.isSubmission),
            getApplicationSections(right.applicant, right.isSubmission),
        ).map(({ key, left: leftNode, right: rightNode }) => (
            <Fragment key={key}>
                <CompareSideProvider value="left">
                    <div data-testid={`compare-left-${key}`}>{leftNode}</div>
                </CompareSideProvider>
                <CompareSideProvider value="right">
                    <div data-testid={`compare-right-${key}`}>{rightNode}</div>
                </CompareSideProvider>
            </Fragment>
        ))}
    </AlignedCompareGrid>
);
